// extracted by mini-css-extract-plugin
module.exports = {"page":"Page-module--page--2nMky","page__inner":"Page-module--page__inner--2M_vz","page__title":"Page-module--page__title--GPD8L","page__body":"Page-module--page__body--Ic6i6"};